export default {
    url: '/materials',
    template: `
        <ui-view></ui-view>
    `,
    data: {
        canAccess: (AuthService, PrivilegeService) => {
            return PrivilegeService.canManageMaterials();
        }
    },
    abstract: true,
    controller ($state) {
        this.$state = $state;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/materials/index.js